import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useTitle from '../../hooks/useTitle';

/**
 * Returns wrapped component while updating document.title with the title prop
 * Also makes sure there's margin from the sidebar.
 * */
export default function Page({ title, children }) {
	const setTitle = useTitle();

	useEffect(() => {
		if (title) {
			setTitle(title);
		}
	}, [setTitle, title]);

	return (
		<div className="mx-auto px-8 py-8 flex flex-col">
			{ children }
		</div>
	);
}

Page.propTypes = {
	title: PropTypes.string,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]).isRequired,
};

Page.defaultProps = {
	title: undefined,
};
